<template>
  <div class="chatMainCon">
    <div class="chatRoomInfoBar">
      <div class="InfoBox">
        <img :src="getChannelIcon(roomInfo)"
             alt="user-profile"
             width="40" height="40" :class="{'fb': roomInfo.moduleChannelName === 'FACEBOOK_TALK'}">
        <!--<span :class="{'v-badge success rounded floating': isActiveStatus}" style="top:2.2rem"></span>-->

        <div class="txtInfo">
          <div class="namePhoneNum">
            <tooltip
              :text="(roomInfo.customerInfoView.name || roomInfo.customerInfoView.userKey) || ''"
              classes="line-clamp-1 cName"
              :txt-max-width="170"
              :txt-max-height="20"
            />
            <span v-if="roomInfo.customerInfoView.phoneNumber" class="cPhoneMargin">
              ({{ roomInfo.customerInfoView.phoneNumber }})
            </span>
          </div>
          <div class="statusDate">
            <span class="blue-6">{{ getChatRoomStatus(isAllStatus) }}</span>
            <span class="gray-7">(受付日時 : {{ printTalkRequestTime(roomInfo.createDate) }})</span>
          </div>
        </div>
      </div>
      <div class="btnInfo">
        <VuePerfectScrollbar v-if="isVisibleOrderList" class="orderList">
          <div>注文番号: {{ orderList }}</div>
        </VuePerfectScrollbar>
        <manager-distribution-dashboard :chatRoomId="chatRoomId"
                                        :isManagerAssignChatRoom="isManagerAssignChatRoom()"
                                        v-if="isManagerAssignChatRoom()"
                                        :isPermission="isPermission.assign"
                                        class="distributionBtn">
        </manager-distribution-dashboard>
        <v-btn outline small class="UXbtn small whiteBtn" style="margin-left:5px"
               @click.native="chatHistoryView" v-if="historyShowStatus">チャット内訳
        </v-btn>
      </div>
      <div class="banWordToolbar" v-if="useBanWordCount > 0">
        <i class="UXicon-warning_outlined"></i>NGワードの文字の色は背景色と同じです。 マウスドラッグで確認してください。
      </div>
    </div>
    <VuePerfectScrollbar class="messageArea chat-area-scroll" ref="messageScroll">
      <chat-message-content ref="messageContent"
                            id="chat-messages-area"
                            :messages="messages"
                            :status="status"
                            :userName="findCustomerName(roomInfo.customerInfoView)"
                            :ban-words="banWords"
                            :set-ban-words-count="setBanWordCount"
                            :channelName="roomInfo.moduleChannelName"
                            :icon-url="getChannelIcon(roomInfo)">
      </chat-message-content>
    </VuePerfectScrollbar>
    <div>
      <template v-if="roomInfo.moduleChannelName && roomInfo.moduleChannelName === 'MAIL'">
        <mail-input
          class="mailInput scrollMargin"
          v-if="!isConsultHistoryView && isEnableInputStatus"
          :brandId="roomInfo.brandId"
          :orderList="orderList"
          :ticketDispId="roomInfo.ticketDispId"
          :agentId="agentId"
          :chatRoomId="chatRoomId"
          :is-pick-available="isPickAvailable"
          :active="isDisplaying"
          :status="status"
          :roomInfo="roomInfo"
          :channelName="roomInfo.moduleChannelName"
          :lastMailMessage="lastMailMessage"
          :resizeMailHeight="resizeMailHeight"
          :displayingChatRoomStatus="displayingChatRoomStatus"
          :setMessageScrollBottom="setMessageScrollBottom"
          :isPermission="isPermission.operation"
        ></mail-input>
      </template>
      <template v-if="roomInfo.moduleChannelName && roomInfo.moduleChannelName !== 'MAIL'">
        <chat-room-input
          ref="chatRoomInputArea"
          class="scrollMargin"
          v-if="!isConsultHistoryView && isEnableInputStatus"
          :brandId="roomInfo.brandId"
          :orderList="orderList"
          :agentId="agentId"
          :loginId="loginId"
          :chatRoomId="chatRoomId"
          :is-pick-available="isPickAvailable"
          :active="isDisplaying"
          :status="status"
          :roomInfo="roomInfo"
          :customerInfo="roomInfo.customerInfoView"
          :channelName="roomInfo.moduleChannelName"
          :displayingChatRoomStatus="displayingChatRoomStatus"
          :categoryId="roomInfo.categoryId"
          :distributionOption="roomInfo.distributionOption"
          :isPermission="isPermission.operation"
          @line-reset-connect-input="lineResetConnectInput()"
        ></chat-room-input>
      </template>
    </div>
  </div>
</template>

<script>
import {mapGetters, mapMutations} from 'vuex'
import util from 'util/'
import helper from 'util/helpers'
import chatRoomUtils from 'util/chatroom'
// import messageStore from 'util/messages'
import chatRoomInput from './chat_room_input'
import ChatMessageContent from './chat_message_content'
import eventBus from '@/event_bus'
import eventType from '@/components/operation/enums/eventType'
import mailInput from './mail_input'
import inputHeight from '@/constants/inputHeight'
import moduleType from '@/constants/moduleType'
import managerDistributionDashboard from './manager_distribution_dashboard'
import VuePerfectScrollbar from 'vue-perfect-scrollbar'
import Tooltip from '../../../tooltip'

export default {
  name: 'chat_room',
  data () {
    return {
      settings: {
        maxScrollbarLength: 160
      },
      roomInfo: {name: '', customerInfoView: {name: ''}},
      messages: null,
      displayingChatRoomStatus: '',
      lastMailMessage: null,
      mailHeight: 'DEFAULT',
      mailAddedRows: {
        // 참조, 숨은참조
        // recipients: '',
        files: ''
      },
      banWords: [],
      useBanWordCount: 0,
      isPickAvailable: true,
      availableMapping: true
    }
  },
  created () {
    eventBus.$on('message-update:success', (rs) => {
      setTimeout(() => {
        if (this.chatRoomId === this.displayingChatRoomId) {
          this.getFullMessages(rs)
        }
      })
    })
    eventBus.$on(`${eventType.UPDATE_CHAT_ROOM_INPUT + this.chatRoomId}`, (chatRoomInfo) => {
      // 상담 대기 목록
      if (chatRoomInfo.chatRoomId === this.chatRoomId) {
        this.findOutMappingAvailable()
      }
    })

    if (this.isConsultHistoryView) {
      this.managementChatRoomSearch()
    } else {
      this.roomInfo = helper.findByChatRoomId(this.chatRoomTabList, this.chatRoomId)
      if (this.status === 'ALL') {
        this.displayingChatRoomStatus = helper.findByChatRoomId(this.chatRoomTabList, this.chatRoomId).secondStatus
      } else {
        this.displayingChatRoomStatus = helper.findByChatRoomId(this.chatRoomTabList, this.chatRoomId).status
      }
    }
    this.getFullMessages()

    // 채팅창에 새로운 메세지가 이미지인경우, 해당 이미지가 로드 된 이후 추가적으로 스크롤 맨밑으로 위치 이동 함수 호출
    // 채팅방 첫 로드 이후 이미지 메세지 업데이트 시 : 메세지 업데이트 이벤트 버스 호출 -> chat_room.vue > updated 훅 호출하여 데이터통해 채팅방 및 메세지 전체 재렌더링 -> 이미지 렌더링
    eventBus.$on('setScrollToEnd', (flag) => {
      if (flag) {
        this.scrollToEnd()
      }
    })
  },
  beforeDestroy () {
    eventBus.$off(`${eventType.UPDATE_CHAT_ROOM_INPUT + this.chatRoomId}`)
  },
  destroyed () {
    eventBus.$off(eventType.UPDATE_TAB_CHAT_ROOM_LIST)
  },
  mounted () {
    eventBus.$on(eventType.UPDATE_TAB_CHAT_ROOM_LIST, () => {
      this.displayingChatRoomStatus = this.getRecentlyUpdatedStatus()
    })
    this.checkAvailablePick()
    this.fetchChatRoomBanWords()
  },
  components: {
    chatRoomInput,
    ChatMessageContent,
    mailInput,
    managerDistributionDashboard,
    VuePerfectScrollbar,
    Tooltip
  },
  props: ['chatRoomId', 'status', 'isConsultHistoryView', 'orderList', 'isPermission'],
  computed: {
    ...mapGetters([
      'agentId',
      'loginId',
      'findCustomerName',
      'findCustomerPhoneNumber',
      'findCustomerFullName',
      'chatRoomTabList',
      'inputAreaHeightLevel',
      'alarmedChatRoomId',
      'markedChatRoom',
      'activeChatRoomList',
      'completeChatRoomList',
      'summaryChatRoomList',
      'transferredChatRoomList',
      'displayingChatRoomId',
      'allChatRoomList',
      'mallId',
      'isPossibleWaitingCategory'
    ]),
    displayingChatRoomId () {
      return this.$store.getters.displayingChatRoomId
    },
    isDisplaying () {
      return this.displayingChatRoomId === this.chatRoomId
    },
    isAssignStatus () {
      return this.status === 'ASSIGN'
    },
    isActiveStatus () {
      return (this.status === 'ACTIVE' || this.status === 'TRANSFER')
    },
    isAllStatus () {
      return this.status === 'ALL'
    },
    isSubscribeWaitingStatus () {
      return this.status === 'SUMMARY_WAITING'
    },
    isVisibleOrderList () {
      return this.status === 'SUMMARY_WAITING' && this.orderList && this.orderList.length > 0
    },
    isCompletedStatus () {
      return this.status === 'COMPLETED'
    },
    isWaitingStatus () {
      return this.status === 'WAITING'
    },
    isEnableInputStatus () {
      return this.status !== 'COMPLETED' && this.availableMapping
    },
    getHeight () {
      if (this.isConsultHistoryView) {
        return 'height: 630px'
      }
      if (this.status === 'ACTIVE' || this.status === 'TRANSFER') {
        // 상담중/이관중 이어도 나에게 할당된 방이 아닌 경우, input 높이 제외
        if (!this.availableMapping) {
          return 'height: calc(100vh - 245px);'
        }

        if (this.roomInfo.moduleChannelName === moduleType.MAIL) {
          if (this.mailHeight === inputHeight.MINIMUM) {
            return 'height: calc(100vh - 322px);'
          } else {
            let defaultHeight = 595

            if (this.mailAddedRows.files === inputHeight.FILES_ONE) {
              defaultHeight += 52
            } else if (this.mailAddedRows.files === inputHeight.FILES_TWO) {
              defaultHeight += 88
            }
            return `height: calc(100vh - ${defaultHeight}px);`
          }
        } else {
          switch (this.inputAreaHeightLevel) {
            case 0:
              return 'height: calc(100vh - 410px);'
            case 1:
              return 'height: calc(100vh - 480px);'
            case 2:
              return 'height: calc(100vh - 555px);'
            case 3:
              return 'height: calc(100vh - 630px);'
          }
        }
      } else if (this.status === 'SUMMARY_WAITING') {
        return 'height: calc(100vh - 307px);'
      } else if (chatRoomUtils.showPickButton(this.status, this.displayingChatRoomStatus, this.roomInfo.distributionOption, this.isPickAvailable)) {
        // 전체 탭에서 대기중인 상담방이면서 '상담 배분 관리'를 사용중일때
        // 상담방의 카테고리와 상담사의 배분받은 카테고리가 다를경우 'height: calc(100vh - 245px);'를 적용
        if (!this.isPermission.operation) {
          return 'height: calc(100vh - 245px);'
        } else {
          if (this.roomInfo.distributionOption === 'CATEGORY_ASSIGNMENT' || this.roomInfo.distributionOption === 'CATEGORY_AUTO_ASSIGNMENT') {
            if (!this.isPossibleWaitingCategory(this.roomInfo.categoryId)) {
              return 'height: calc(100vh - 245px);'
            }
          }
          return 'height: calc(100vh - 307px);'
        }
      } else {
        return 'height: calc(100vh - 245px);'
      }
    },
    historyShowStatus () {
      if (this.roomInfo.moduleChannelName === moduleType.MAIL) return false
      return this.isConsultHistoryView !== true
    }
  },
  watch: {
    chatRoomId (newValue) {
      this.useBanWordCount = 0 // 금칙어 포함수 초기화
      this.messages = null // 초기화
      this.checkAvailablePick()
      this.getFullMessages()
      if (this.isConsultHistoryView) {
        this.managementChatRoomSearch()
      }
    },
    displayingChatRoomId (newVal, oldVal) {
      this.displayingChatRoomStatus = this.getRecentlyUpdatedStatus()
    },
    displayingChatRoomStatus (newVal) {
      this.changeDisplayingChatRoomStatus(newVal)
    },
    messages () {
      if (this.messages && this.messages.length > 0 && this.roomInfo.moduleChannelName === moduleType.MAIL) {
        this.lastMailMessage = this.messages.slice(0).reverse().find(message => message.senderType === 'USER').content
      }
    }
  },
  updated () {
    this.$nextTick(() => {
      this.scrollToEnd()
    })
  },
  methods: {
    ...mapMutations([
      'setOrderList',
      'changeDisplayingChatRoomStatus'
    ]),
    lineResetConnectInput () {
      this.$emit('line-reset-connect')
    },
    scrollToEnd () {
      if (!this.$refs.messageScroll || !this.$refs.messageScroll.$el) {
        return
      }
      if (!this.$refs.messageContent || !this.$refs.messageContent.$el) {
        return
      }
      const container = this.$refs.messageScroll.$el
      const messageArea = this.$refs.messageContent.$el

      if (!messageArea.clientHeight || !container.clientHeight) {
        return
      }
      const msgType = this.messages ? this.messages[this.messages.length - 1].messageType : ''
      setTimeout(() => {
        container.scrollTop = messageArea.clientHeight - container.clientHeight
      }, msgType === 'PHOTO' ? 30 : 0)
    },
    toggleChatSidebar () {
      this.$store.dispatch('toggleChatSidebar', true)
    },
    managementChatRoomSearch () {
      this.axios.get('/api/chat/fetchChatRoomInfo', {
        params: {
          chatRoomId: this.chatRoomId
        }
      }).then(result => {
        if (result.data.code === 0) {
          this.roomInfo = result.data.data
        } else {
          this.$alertMsg(result.data.message)
        }
      })
    },
    // 메시지 모듈에 해당 상담방의 메시지가 없으면 api로 조회 요청
    getFullMessages (rs) {
      if (rs && this.messages) {
        this.messages.push(rs)
      } else {
        this.axios.get(`/api/chat/${this.chatRoomId}/messages?page=1&size=100&ascending=false`).then(res => {
          if (res.data.code === 0) {
            this.messages = res.data.data
            this.messages.sort((a, b) => {
              return a.id < b.id ? -1 : a.id > b.id ? 1 : 0
            })
            // this.$forceUpdate()
          }
        })
      }
    },
    findOutMappingAvailable () {
      this.axios.get('/api/chat/availableMapping', {
        params: {
          chatRoomId: this.chatRoomId
        }
      }).then(result => {
        if (result.data.code === 0) {
          this.availableMapping = result.data.data
        }
      })
    },
    // 상담시작하기 가능 여부 확인
    checkAvailablePick () {
      this.axios.get(`/api/chat/${this.chatRoomId}/pickAvailable`)
        .then(res => {
          if (res.data.code === 0) {
            let data = res.data.data
            this.isPickAvailable = data.isPickAvailable
          }
        })
    },
    // 금칙어 조회
    fetchChatRoomBanWords () {
      this.axios.get(`/api/chat/${this.chatRoomId}/banWords`)
        .then(res => {
          if (res.data.code === 0) {
            let data = res.data.data
            data.forEach(s => {
              this.banWords.push(s)
            })
          }
        })
    },
    setBanWordCount (val) {
      if (this.useBanWordCount === 0) {
        this.useBanWordCount = val
      }
    },
    printCustomerName () {
      let customerName = this.findCustomerFullName(this.roomInfo.customerInfoView)
      let phoneNumber = this.findCustomerPhoneNumber(this.roomInfo.customerInfoView)

      return phoneNumber === undefined ? customerName : customerName + ' (' + phoneNumber + ')'
    },
    printTalkRequestTime (createDate) {
      return helper.printTimeStampMMDDHHmmFromDateTime(createDate)
    },
    chatHistoryView () {
      eventBus.$emit('chatHistoryViewOpenEvent', this.roomInfo)
    },
    getChannelIcon (room) {
      return room.iconUrl ? room.iconUrl : util.getChatRoomIcon(room.moduleChannelName)
    },
    getChatRoomStatus (isAllStatus) {
      let status = isAllStatus ? this.displayingChatRoomStatus : this.status
      switch (status) {
        case 'ASSIGN':
          return '割当'
        case 'ACTIVE':
          return '対応中'
        case 'TRANSFER':
          return isAllStatus ? '転送' : '相談中'
        case 'SUMMARY_WAITING':
          return '後処理'
        case 'COMPLETED':
          return '終了'
        case 'WAITING':
          return '待機中'
        default:
          return ''
      }
    },
    getRecentlyUpdatedStatus () {
      let chatRoom = helper.findByChatRoomId(this.chatRoomTabList, this.displayingChatRoomId)
      if (helper.isObjectValid(chatRoom)) {
        if (chatRoom.status === 'ALL') {
          return chatRoom.secondStatus
        } else {
          return chatRoom.status
        }
      }
    },
    resizeMailHeight (resizeVal, addedRows) {
      this.mailHeight = resizeVal
      this.mailAddedRows = addedRows
    },
    setMessageScrollBottom () {
      if (this.$el.querySelector('.ps-container')) this.$refs.messageScroll.$el.scrollTop = this.$el.querySelector('.ps-container').scrollHeight
    },
    isManagerAssignChatRoom () {
      let chatRoomInfo = helper.findByChatRoomId(this.chatRoomTabList, this.displayingChatRoomId)
      if (chatRoomInfo && this.$route.path !== '/report/consult_history') {
        let managerAssignChatRoom = chatRoomInfo.status === 'ACTIVE' || chatRoomInfo.status === 'ASSIGN' || chatRoomInfo.status === 'WAITING' || chatRoomInfo.status === 'TRANSFER'
        // 전체탭에서 방을 선택하면 status 가 ALL 이라 secondStatus 조회
        if (chatRoomInfo.status === 'ALL' && chatRoomInfo.secondStatus) {
          managerAssignChatRoom = chatRoomInfo.secondStatus === 'ACTIVE' || chatRoomInfo.secondStatus === 'ASSIGN' || chatRoomInfo.secondStatus === 'WAITING' || chatRoomInfo.secondStatus === 'TRANSFER'
        }
        return this.isPermission.assign && managerAssignChatRoom
      }
      return false
    }
  }
}
</script>

<style lang="scss">
  .chatMainCon {
    position: relative;
    display: flex;
    flex-direction: column;
    height: calc(100vh - 185px);
    .chatRoomInfoBar {
      min-height: 67px;
      max-height: 67px;
      background-color: #f8f8f8;
      border-bottom: 1px solid $gray-3;
      padding: 0 10px 0 10px;
      display: flex;
      flex-direction: row;
      align-items: center;
      justify-content: space-between;
      .InfoBox {
        display: flex;
        flex-direction: row;
        align-items: center;
        img:not(.fb) {
          border-radius: 50%;
          object-fit: contain;
        }
        .txtInfo {
          padding-left: 10px;
          flex-grow: 1;
          display: flex;
          flex-direction: column;
          justify-content: center;
          .namePhoneNum {
            display: flex;
            align-items: center;
            @include font-style(14px, bold, 20px);
            color: $gray-9;
            .cName {
              @include font-style(14px, bold, 20px);
              color: $gray-9;
            }
            .cPhoneMargin {
              margin-left: 5px;
            }
          }
          .statusDate {
            margin-top: -5px;
            span {
              @include font-style(12px, normal, 16px);
              color: $gray-7;
              &.blue-6 {
                color: #ff8c8c;
              }
            }
          }
        }
      }
      .btnInfo {
        display: inline-flex;
        align-items: center;
        /*flex-direction: row;*/
        .orderList {
          font-size: 12px;
          color: $pb_6;
          @include font-style(12px, 400, 16px);
          border: 1px solid $gray-3;
          border-radius: 5px;
          background-color: $gray-0;
          width: 195px;
          max-height: 42px;
          padding: 4px;
        }
        .distributionBtn {
          margin-left: 10px;
          .v-dialog__activator {
            display: flex;
          }
        }
      }
      .banWordToolbar {
        position: absolute;
        background: rgba(7, 7, 7, 0.6);
        top: 67px;
        left: 0;
        width: 100%;
        z-index: 10;
        display: flex;
        align-items: center;
        justify-content: center;
        padding: 4px 0 4px 0;
        font-size: 14px;
        line-height: 18px;
        font-weight: bold;
        color: $gray-0;
        &::before {
          content: '';
          position: relative;
          left: 14px;
          width: 10px;
          height: 10px;
          background: white;
          border-radius: 10px;
        }
        i {
          font-size: 18px;
          color: $red_6;
          margin-right: 3px;
          z-index: 1;
        }
      }
    }
    .messageArea {
      flex: 1 auto;
    }
    .chatInputBox {
      background-color: $gray-0;
      border-top: 1px solid $gray-3;
      border-bottom: 1px solid $gray-3;
      .activeInput {
        margin: 12px;
        .text {
          display: flex;
          border: 1px solid $gray-3;
          border-radius: 5px;
          .chatTextArea {
            border-radius: 5px 0 0 5px;
            background-color: $gray-0;
            &.theme--light.v-text-field--outline:not(.v-input--is-focused) {
              .v-input__slot:hover {
                border: none;
              }
            }
            &.theme--light.v-text-field--outline.v-input--is-focused .v-input__slot {
              border: none;
            }
            &.theme--light.v-text-field--outline .v-input__slot {
              border: none;
            }
            &.v-input--is-disabled {
              textarea {
                opacity:.5;
                text-align:center;
                margin: 30px;
              }
            }
            .v-input__slot {
              padding: 0 !important;
              height: auto;
              textarea {
                padding: 12px  !important;
                color:#414141;
                font-size:14px;
                line-height:22px;
              }
            }
            textarea::placeholder {
              color:#919191  !important;
              font-size:14px;
            }
          }
          .sendBtn {
            &.v-btn {
              margin: 0;
              height: auto;
              border-radius: 0 5px 5px 0;
            }
            i {
              @include font-style(30px, bold, normal);
              color: $pb_6;
            }
            &.v-btn--disabled {
              background: #f5f5f5 !important;
              .v-btn__content {
                opacity: .5;
              }
            }
          }
        }
      }
      .options {
        padding: 12px 0 0 0;
        display: flex;
        align-items: center;
        .resizeOptionBox {
          display: flex;
          align-items: center;
          &:not(.resizeBtnBox) {
            div {
              border: 0.5px solid $gray-3;
              height: 32px;
              width: 32px;
              @include font-style(12px, normal, normal);
              border-radius: 5px;
              margin-right: 5px;
              color: $gray-6;
              cursor: pointer;
              display: flex;
              justify-content: center;
              align-items: center;
              &.on {
                background-color: $gray-3;
                color: $gray-7;
                font-weight: bold;
              }
              &:hover {
                background-color: $gray-2;
              }
            }
          }
          .v-btn {
            background: $gray-0;
            border: 0.5px solid $gray-3;
            border-radius: 5px;
            margin: 0;
            &:not(:last-child) {
              margin-right: 5px;
            }
            &:before {
              border-radius: 5px;
            }
            i {
              color: #919191;
            }
            &.selected {
              background: $gray-3;
              border: 0.5px solid $gray-4;
              i {
                color: $gray-8;
              }
            }
          }
        }
        .option2 {
          display: flex;
          flex-grow: 1;
          justify-content: flex-end;
        }
        .option3 {
          display: flex;
          justify-content: right;
        }
      }
    }
    .actionActivatorWrap {
      margin: 12px;
      display: flex;
      flex-grow: 1;
      > div {
        width: 100%;
        .actionActivator {
          background-color: #ff8c8c;
          border-radius: 5px;
          cursor: pointer;
          width: 100%;
          color: $gray-0;
          height: 40px;
          display: flex;
          align-items: center;
          justify-content: center;
          font-size: 14px;
          font-weight: 500;
          &.summary {
            background-color: $pb_6;
          }
          &.pick {
            background-color: $red_5;
          }
        }
      }
    }
    .emojiPicker {
      position: relative;
      outline: none;
      .v-btn .emojiTooltip{
        display: flex;
        align-items: center;
      }
      .emojiPopup {
        background-color: white;
        box-sizing: content-box;
        padding: 10px;
        width: 395px!important;
        height: 310px;
        display: flex;
        align-items: center;
        justify-content: center;
        flex-wrap: wrap;
        &:not(.vue-swatches--inline) {
          position: absolute;
          bottom: 50px;
          left: -85px;
          display: block;
          overflow: auto;
          border-radius: 5px;
          box-shadow: 0 3px 6px 0 rgba(0, 0, 0, 0.46);
          z-index: 50;
        }
        img {
          width: 35px;
          height: 35px;
          border-radius: 5px;
          border: 1px solid transparent;
          cursor: pointer;
          margin: 1px;
          &:hover {
            background-color: $gray-2;
          }
        }
        ul {
          &.kakao {
            padding:0;
            width:100%;
            display:table;
            li {
              position:relative;
              float:left;
              list-style: none;
              width: 35px;
              height: 35px;
              border-radius: 5px;
              border: 1px solid transparent;
              cursor: pointer;
              margin: 2px;
              background: url(https://public-common-sdk-outaigate.s3.ap-northeast-3.amazonaws.com/image/img_sprite01.png) no-repeat 0 0;
              &:hover {
                background-color: $gray-2;
              }
            }
          }
          &.line {
            padding:0;
            width:100%;
            display:table;
            li {
              position:relative;
              float:left;
              list-style: none;
              width: 40px;
              height: 40px;
              cursor: pointer;
              margin: 1px;
              background: url(https://public-common-sdk-outaigate.s3.ap-northeast-3.amazonaws.com/image/line_emoji.png) no-repeat 0 0;
              &:hover {
                background-color: $gray-2;
              }
            }
          }
        }
      }
    }
  }
</style>

<style lang="scss" scoped>
  @media (max-width: 1550px) {
    .scrollMargin {
      margin-bottom: 15px;
    }
  }
/*/deep/ .mailInput {*/
  /*padding-bottom: 15px;*/
/*}*/
</style>



// WEBPACK FOOTER //
// src/components/operation/fragments/chat_area/chat_room.vue